import { render } from "./variant-collection-slideout.vue?vue&type=template&id=3aa228ca"
import script from "./variant-collection-slideout.vue?vue&type=script&lang=js"
export * from "./variant-collection-slideout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__